import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import './styels/tailwind.css';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import SignUp from './pages/Sign-up';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import PopupMap from './components/PopupMap';
import Signin from './pages/Sign-in';
import ContactUs from './pages/ContactUs';
import UserProfile from './pages/UserProfile';
import UserActivites from './pages/UserActivites';
import RequestNeeds from './pages/RequestNeeds';
import { useSelector } from 'react-redux';
import { messaging } from './config/firebaseInitial';
import AboutUs from './pages/AboutUs';
function App() {
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  useEffect(() => {
    messaging
      .requestPermission()
      .then(async function () {
        // const token = await messaging.getToken();
      })
      .catch(function (err) { });
  }, []);
  return (
    <div className='main-cont '>
      <Navbar />

      <Switch>
        <Route exact path='/'>
          <Header />
          <AboutSection />
        </Route>
        <Route path='/map' render={(props) => <PopupMap {...props} />} />
        <Route path='/dashboard' component={Dashboard} />
        <Route path='/contact-us' component={ContactUs} />
        <Route path='/about-us' component={AboutUs} />
        <Route path='/ask-for-help' component={RequestNeeds} />
        <Route path='/sign-up'>
          {!isAuthenticated ? <SignUp /> : <Redirect to='/' />}
        </Route>
        <Route path='/sign-in'>
          {!isAuthenticated ? <Signin /> : <Redirect to='/' />}
        </Route>
        <Route path='/profile'>
          {isAuthenticated ? <UserProfile /> : <Redirect to='/' />}
        </Route>
        <Route path='/activites'>
          {isAuthenticated ? <UserActivites /> : <Redirect to='/' />}
        </Route>
        <Redirect to='/' />
      </Switch>

      <Footer />
    </div>
  );
}

export default App;
